export const navbarStyles = {

  bar: {

    backgroundColor: 'var(--mantine-color-brand-9)',

    height: '70px',
    paddingTop: '9px',

  },

  links: {

    backgroundColor: 'var(--mantine-color-brand-9)',
    color: 'var(--mantine-color-white)',
    height: '50px',
    borderTop: '2px solid var(--mantine-color-white)',
    borderBottom: '2px solid var(--mantine-color-white)',
    outline: '5px solid var(--mantine-color-white)',
    outlineBottom: '5px solid var(--mantine-color-white)',
    outlineOffset: '2px',
    
  },
}